import { default as auto_45reserveGsyCQGJrBTMeta } from "/app/pages/after-order/auto-reserve.vue?macro=true";
import { default as index4NezOMZDrlMeta } from "/app/pages/after-order/auto/index.vue?macro=true";
import { default as confirmationRY3lBgeGjdMeta } from "/app/pages/after-order/confirmation.vue?macro=true";
import { default as indexdfSncMV8QQMeta } from "/app/pages/after-order/index.vue?macro=true";
import { default as indexqa1C4zLIGuMeta } from "/app/pages/after-order/payment-waiting/index.vue?macro=true";
import { default as transporter2L9yg1GRB5Meta } from "/app/pages/after-order/transporter.vue?macro=true";
import { default as indexbUTYpCP6oZMeta } from "/app/pages/app/index.vue?macro=true";
import { default as apt_45indexHv3XLrKiN2Meta } from "/app/pages/apt-index.vue?macro=true";
import { default as indexs2TtEAVz0DMeta } from "/app/pages/auto-reserve/index.vue?macro=true";
import { default as gift_45cardQkVBorcEpYMeta } from "/app/pages/b2b/gift-card.vue?macro=true";
import { default as indexzknaIoIHO3Meta } from "/app/pages/b2b/index.vue?macro=true";
import { default as residenceTO90BAnnjaMeta } from "/app/pages/b2b/residence.vue?macro=true";
import { default as captcha_45framefaZaz4dKqqMeta } from "/app/pages/captcha-frame.vue?macro=true";
import { default as captchaGfVEfPgzjlMeta } from "/app/pages/captcha.vue?macro=true";
import { default as combined_45routeggj9LtS8LpMeta } from "/app/pages/combined-route.vue?macro=true";
import { default as _91airport_938I0p5SEiV2Meta } from "/app/pages/flight-info/[airport].vue?macro=true";
import { default as index0fGT0R7p02Meta } from "/app/pages/flight-info/index.vue?macro=true";
import { default as flight_45infoeUatO2CQczMeta } from "/app/pages/flight-info.vue?macro=true";
import { default as indexl4EdCGhmEGMeta } from "/app/pages/hotel/[city]/[hotelName]/index.vue?macro=true";
import { default as indexkhH8ePnzUaMeta } from "/app/pages/hotel/[city]/index.vue?macro=true";
import { default as _91rootName_93PiLmSgbIYrMeta } from "/app/pages/index/[rootName].vue?macro=true";
import { default as air_45taxiV1tr9pPw1oMeta } from "/app/pages/index/air-taxi.vue?macro=true";
import { default as bus_45ticketrqiYQsKUNfMeta } from "/app/pages/index/bus-ticket.vue?macro=true";
import { default as _91code_93hWX7QeCC2wMeta } from "/app/pages/index/buses/[code].vue?macro=true";
import { default as _91provider_93eoOLjyM5IvMeta } from "/app/pages/index/buses/providers/[provider].vue?macro=true";
import { default as indexW1X9WJECXYMeta } from "/app/pages/index/buses/providers/index.vue?macro=true";
import { default as _91code_93HRhttBAUs4Meta } from "/app/pages/index/car-rental/[code].vue?macro=true";
import { default as indexz14zF0dozcMeta } from "/app/pages/index/car-rental/index.vue?macro=true";
import { default as charterK04y7OvSmcMeta } from "/app/pages/index/charter.vue?macro=true";
import { default as _91code_93L8jhn2dbQOMeta } from "/app/pages/index/flights/[code].vue?macro=true";
import { default as _91provider_93N9x8N3oyjBMeta } from "/app/pages/index/flights/providers/[provider].vue?macro=true";
import { default as indexRjPRIRUIAXMeta } from "/app/pages/index/flights/providers/index.vue?macro=true";
import { default as index7dVwbHWQYgMeta } from "/app/pages/index/hotel/index.vue?macro=true";
import { default as index3J5r3Sf7qAMeta } from "/app/pages/index/index.vue?macro=true";
import { default as international_45flightshROP26skMMMeta } from "/app/pages/index/international-flights.vue?macro=true";
import { default as plane_45ticketWyyA4ZcXfsMeta } from "/app/pages/index/plane-ticket.vue?macro=true";
import { default as _91code_933ZOKnJtQdtMeta } from "/app/pages/index/ship-ticket/[code].vue?macro=true";
import { default as indexzO6c3cwHqmMeta } from "/app/pages/index/ship-ticket/index.vue?macro=true";
import { default as _91code_93SWH3sFQStCMeta } from "/app/pages/index/taxi/[code].vue?macro=true";
import { default as indexEN4lYa0X3SMeta } from "/app/pages/index/taxi/index.vue?macro=true";
import { default as tour7G4rBNNv4RMeta } from "/app/pages/index/tour.vue?macro=true";
import { default as _91inner_9337DlmEp8hSMeta } from "/app/pages/index/train-ticket/[name]/[inner].vue?macro=true";
import { default as indexMAd01lhldsMeta } from "/app/pages/index/train-ticket/[name]/index.vue?macro=true";
import { default as indexwtdfqzQe8qMeta } from "/app/pages/index/train-ticket/index.vue?macro=true";
import { default as _91code_93P83VAo1a0XMeta } from "/app/pages/index/trains/[code].vue?macro=true";
import { default as _91provider_930qLpraNgw7Meta } from "/app/pages/index/trains/providers/[provider].vue?macro=true";
import { default as index51ab2qa2LuMeta } from "/app/pages/index/trains/providers/index.vue?macro=true";
import { default as indexFiidx42IKNMeta } from "/app/pages/index.tsx?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as mr_45index8CMfyvjNFmMeta } from "/app/pages/mr-index.vue?macro=true";
import { default as downloadTicketsoT66ur7rTOMeta } from "/app/pages/org/downloadTickets.vue?macro=true";
import { default as hotelFactorecHqiFKz7wMeta } from "/app/pages/org/hotelFactor.vue?macro=true";
import { default as index55WIOoOHBHMeta } from "/app/pages/org/purchaseReport/index.vue?macro=true";
import { default as details5TkiLf315WMeta } from "/app/pages/org/statusReport/details.vue?macro=true";
import { default as index8gntQCwxHdMeta } from "/app/pages/org/statusReport/index.vue?macro=true";
import { default as org2n1R1gxsfBMeta } from "/app/pages/org.vue?macro=true";
import { default as addPassengerWGlfZVmf25Meta } from "/app/pages/panel/addPassenger.vue?macro=true";
import { default as _91billId_93HauutDKGzNMeta } from "/app/pages/panel/auto-reserve/[id]/[billId].vue?macro=true";
import { default as indexPaguqZLPkrMeta } from "/app/pages/panel/auto-reserve/[id]/index.vue?macro=true";
import { default as indexg7ylByDl4VMeta } from "/app/pages/panel/auto-reserve/index.vue?macro=true";
import { default as historyF5Dq7DwnNdMeta } from "/app/pages/panel/club/history.vue?macro=true";
import { default as indexmjXSFkcLsFMeta } from "/app/pages/panel/club/index.vue?macro=true";
import { default as level52MLFTApfqMeta } from "/app/pages/panel/club/level.vue?macro=true";
import { default as scoresMKuXzg4bneMeta } from "/app/pages/panel/club/scores.vue?macro=true";
import { default as index4cf5Ag9Q9yMeta } from "/app/pages/panel/credit/index.vue?macro=true";
import { default as indexo76gkEoZmgMeta } from "/app/pages/panel/gift-cards/index.vue?macro=true";
import { default as indexnCUfp2msl3Meta } from "/app/pages/panel/index/index.vue?macro=true";
import { default as indexkjLCehs3zuMeta } from "/app/pages/panel/messages/index.vue?macro=true";
import { default as indexoikjwP7eo2Meta } from "/app/pages/panel/pax/index.vue?macro=true";
import { default as indexYYB617BrvZMeta } from "/app/pages/panel/reserves/index.vue?macro=true";
import { default as index0T43KXNAjlMeta } from "/app/pages/panel/robot/index.vue?macro=true";
import { default as indexb5G7ldEeI6Meta } from "/app/pages/panel/trackings/index.vue?macro=true";
import { default as panel7hVK6F0xvXMeta } from "/app/pages/panel.vue?macro=true";
import { default as indexaeouN7Kzh7Meta } from "/app/pages/profile/index.vue?macro=true";
import { default as indexD5v8i8GbLlMeta } from "/app/pages/reserve/auto-reserve/filters/index.vue?macro=true";
import { default as indexXW1ZIMTKwyMeta } from "/app/pages/reserve/auto-reserve/index.vue?macro=true";
import { default as indexvMGHc9fqGoMeta } from "/app/pages/reserve/auto/index.vue?macro=true";
import { default as floating3QCs7DkpofMeta } from "/app/pages/reserve/floating.vue?macro=true";
import { default as indexkYjUxQxG9IMeta } from "/app/pages/reserve/form/index.vue?macro=true";
import { default as indexnMeaEGSw8zMeta } from "/app/pages/reserve/prepay/index.vue?macro=true";
import { default as indexsh8o87md7VMeta } from "/app/pages/reserve/raise/index.vue?macro=true";
import { default as indexmjydbmT8M8Meta } from "/app/pages/services/index.vue?macro=true";
import { default as detailsOV1ee9OX0kMeta } from "/app/pages/support/index/details.vue?macro=true";
import { default as faqSzLyQjvpX7Meta } from "/app/pages/support/index/faq.vue?macro=true";
import { default as feedbackEuOmwbcx8oMeta } from "/app/pages/support/index/feedback.vue?macro=true";
import { default as paymentxxxhb6dQFZMeta } from "/app/pages/support/index/guide/payment.vue?macro=true";
import { default as reservationbA9pInCuy0Meta } from "/app/pages/support/index/guide/reservation.vue?macro=true";
import { default as guidey9hie2KZVZMeta } from "/app/pages/support/index/guide.vue?macro=true";
import { default as ibane44omNhhnSMeta } from "/app/pages/support/index/iban.vue?macro=true";
import { default as privacy_45policynKsIz79tYoMeta } from "/app/pages/support/index/privacy-policy.vue?macro=true";
import { default as terms_45and_45conditionsK01Mq8jqJ7Meta } from "/app/pages/support/index/terms-and-conditions.vue?macro=true";
import { default as trackingeZdpDvxkeYMeta } from "/app/pages/support/index/tracking.vue?macro=true";
import { default as uploadIJZ1qPZvsuMeta } from "/app/pages/support/index/upload.vue?macro=true";
import { default as who_45is_45aptcHZo0UVpwkMeta } from "/app/pages/support/index/who-is-apt.vue?macro=true";
import { default as who_45is_45hemF9xvw5aDYMeta } from "/app/pages/support/index/who-is-he.vue?macro=true";
import { default as indexrVEAE3qysDMeta } from "/app/pages/support/index.vue?macro=true";
import { default as indexOltAc8HSPiMeta } from "/app/pages/view/index.vue?macro=true";
import { default as widgetzMSPHa954TMeta } from "/app/pages/widget.vue?macro=true";
import { default as component_45stubnO9MU04yTUMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubnO9MU04yTU } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: auto_45reserveGsyCQGJrBTMeta?.name ?? "after-order-auto-reserve",
    path: auto_45reserveGsyCQGJrBTMeta?.path ?? "/after-order/auto-reserve",
    meta: auto_45reserveGsyCQGJrBTMeta || {},
    alias: auto_45reserveGsyCQGJrBTMeta?.alias || [],
    redirect: auto_45reserveGsyCQGJrBTMeta?.redirect,
    component: () => import("/app/pages/after-order/auto-reserve.vue").then(m => m.default || m)
  },
  {
    name: index4NezOMZDrlMeta?.name ?? "after-order-auto",
    path: index4NezOMZDrlMeta?.path ?? "/after-order/auto",
    meta: index4NezOMZDrlMeta || {},
    alias: index4NezOMZDrlMeta?.alias || [],
    redirect: index4NezOMZDrlMeta?.redirect,
    component: () => import("/app/pages/after-order/auto/index.vue").then(m => m.default || m)
  },
  {
    name: confirmationRY3lBgeGjdMeta?.name ?? "after-order-confirmation",
    path: confirmationRY3lBgeGjdMeta?.path ?? "/after-order/confirmation",
    meta: confirmationRY3lBgeGjdMeta || {},
    alias: confirmationRY3lBgeGjdMeta?.alias || [],
    redirect: confirmationRY3lBgeGjdMeta?.redirect,
    component: () => import("/app/pages/after-order/confirmation.vue").then(m => m.default || m)
  },
  {
    name: indexdfSncMV8QQMeta?.name ?? "after-order",
    path: indexdfSncMV8QQMeta?.path ?? "/after-order",
    meta: indexdfSncMV8QQMeta || {},
    alias: indexdfSncMV8QQMeta?.alias || [],
    redirect: indexdfSncMV8QQMeta?.redirect,
    component: () => import("/app/pages/after-order/index.vue").then(m => m.default || m)
  },
  {
    name: indexqa1C4zLIGuMeta?.name ?? "after-order-payment-waiting",
    path: indexqa1C4zLIGuMeta?.path ?? "/after-order/payment-waiting",
    meta: indexqa1C4zLIGuMeta || {},
    alias: indexqa1C4zLIGuMeta?.alias || [],
    redirect: indexqa1C4zLIGuMeta?.redirect,
    component: () => import("/app/pages/after-order/payment-waiting/index.vue").then(m => m.default || m)
  },
  {
    name: transporter2L9yg1GRB5Meta?.name ?? "after-order-transporter",
    path: transporter2L9yg1GRB5Meta?.path ?? "/after-order/transporter",
    meta: transporter2L9yg1GRB5Meta || {},
    alias: transporter2L9yg1GRB5Meta?.alias || [],
    redirect: transporter2L9yg1GRB5Meta?.redirect,
    component: () => import("/app/pages/after-order/transporter.vue").then(m => m.default || m)
  },
  {
    name: indexbUTYpCP6oZMeta?.name ?? "app",
    path: indexbUTYpCP6oZMeta?.path ?? "/app",
    meta: indexbUTYpCP6oZMeta || {},
    alias: indexbUTYpCP6oZMeta?.alias || [],
    redirect: indexbUTYpCP6oZMeta?.redirect,
    component: () => import("/app/pages/app/index.vue").then(m => m.default || m)
  },
  {
    name: apt_45indexHv3XLrKiN2Meta?.name ?? "apt-index",
    path: apt_45indexHv3XLrKiN2Meta?.path ?? "/apt-index",
    meta: apt_45indexHv3XLrKiN2Meta || {},
    alias: apt_45indexHv3XLrKiN2Meta?.alias || [],
    redirect: apt_45indexHv3XLrKiN2Meta?.redirect,
    component: () => import("/app/pages/apt-index.vue").then(m => m.default || m)
  },
  {
    name: indexs2TtEAVz0DMeta?.name ?? "auto-reserve",
    path: indexs2TtEAVz0DMeta?.path ?? "/auto-reserve",
    meta: indexs2TtEAVz0DMeta || {},
    alias: indexs2TtEAVz0DMeta?.alias || [],
    redirect: indexs2TtEAVz0DMeta?.redirect,
    component: () => import("/app/pages/auto-reserve/index.vue").then(m => m.default || m)
  },
  {
    name: gift_45cardQkVBorcEpYMeta?.name ?? "b2b-gift-card",
    path: gift_45cardQkVBorcEpYMeta?.path ?? "/b2b/gift-card",
    meta: gift_45cardQkVBorcEpYMeta || {},
    alias: gift_45cardQkVBorcEpYMeta?.alias || [],
    redirect: gift_45cardQkVBorcEpYMeta?.redirect,
    component: () => import("/app/pages/b2b/gift-card.vue").then(m => m.default || m)
  },
  {
    name: indexzknaIoIHO3Meta?.name ?? "b2b",
    path: indexzknaIoIHO3Meta?.path ?? "/b2b",
    meta: indexzknaIoIHO3Meta || {},
    alias: indexzknaIoIHO3Meta?.alias || [],
    redirect: indexzknaIoIHO3Meta?.redirect,
    component: () => import("/app/pages/b2b/index.vue").then(m => m.default || m)
  },
  {
    name: residenceTO90BAnnjaMeta?.name ?? "b2b-residence",
    path: residenceTO90BAnnjaMeta?.path ?? "/b2b/residence",
    meta: residenceTO90BAnnjaMeta || {},
    alias: residenceTO90BAnnjaMeta?.alias || [],
    redirect: residenceTO90BAnnjaMeta?.redirect,
    component: () => import("/app/pages/b2b/residence.vue").then(m => m.default || m)
  },
  {
    name: captcha_45framefaZaz4dKqqMeta?.name ?? "captcha-frame",
    path: captcha_45framefaZaz4dKqqMeta?.path ?? "/captcha-frame",
    meta: captcha_45framefaZaz4dKqqMeta || {},
    alias: captcha_45framefaZaz4dKqqMeta?.alias || [],
    redirect: captcha_45framefaZaz4dKqqMeta?.redirect,
    component: () => import("/app/pages/captcha-frame.vue").then(m => m.default || m)
  },
  {
    name: captchaGfVEfPgzjlMeta?.name ?? "captcha",
    path: captchaGfVEfPgzjlMeta?.path ?? "/captcha",
    meta: captchaGfVEfPgzjlMeta || {},
    alias: captchaGfVEfPgzjlMeta?.alias || [],
    redirect: captchaGfVEfPgzjlMeta?.redirect,
    component: () => import("/app/pages/captcha.vue").then(m => m.default || m)
  },
  {
    name: combined_45routeggj9LtS8LpMeta?.name ?? "combined-route",
    path: combined_45routeggj9LtS8LpMeta?.path ?? "/combined-route",
    meta: combined_45routeggj9LtS8LpMeta || {},
    alias: combined_45routeggj9LtS8LpMeta?.alias || [],
    redirect: combined_45routeggj9LtS8LpMeta?.redirect,
    component: () => import("/app/pages/combined-route.vue").then(m => m.default || m)
  },
  {
    name: flight_45infoeUatO2CQczMeta?.name ?? undefined,
    path: flight_45infoeUatO2CQczMeta?.path ?? "/flight-info",
    meta: flight_45infoeUatO2CQczMeta || {},
    alias: flight_45infoeUatO2CQczMeta?.alias || [],
    redirect: flight_45infoeUatO2CQczMeta?.redirect,
    component: () => import("/app/pages/flight-info.vue").then(m => m.default || m),
    children: [
  {
    name: _91airport_938I0p5SEiV2Meta?.name ?? "flight-info-airport",
    path: _91airport_938I0p5SEiV2Meta?.path ?? ":airport()",
    meta: _91airport_938I0p5SEiV2Meta || {},
    alias: _91airport_938I0p5SEiV2Meta?.alias || [],
    redirect: _91airport_938I0p5SEiV2Meta?.redirect,
    component: () => import("/app/pages/flight-info/[airport].vue").then(m => m.default || m)
  },
  {
    name: index0fGT0R7p02Meta?.name ?? "flight-info",
    path: index0fGT0R7p02Meta?.path ?? "",
    meta: index0fGT0R7p02Meta || {},
    alias: index0fGT0R7p02Meta?.alias || [],
    redirect: index0fGT0R7p02Meta?.redirect,
    component: () => import("/app/pages/flight-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexl4EdCGhmEGMeta?.name ?? "hotel-city-hotelName",
    path: indexl4EdCGhmEGMeta?.path ?? "/hotel/:city()/:hotelName()",
    meta: indexl4EdCGhmEGMeta || {},
    alias: indexl4EdCGhmEGMeta?.alias || [],
    redirect: indexl4EdCGhmEGMeta?.redirect,
    component: () => import("/app/pages/hotel/[city]/[hotelName]/index.vue").then(m => m.default || m)
  },
  {
    name: indexkhH8ePnzUaMeta?.name ?? "hotel-city",
    path: indexkhH8ePnzUaMeta?.path ?? "/hotel/:city()",
    meta: indexkhH8ePnzUaMeta || {},
    alias: indexkhH8ePnzUaMeta?.alias || [],
    redirect: indexkhH8ePnzUaMeta?.redirect,
    component: () => import("/app/pages/hotel/[city]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFiidx42IKNMeta?.name ?? undefined,
    path: indexFiidx42IKNMeta?.path ?? "/",
    meta: indexFiidx42IKNMeta || {},
    alias: indexFiidx42IKNMeta?.alias || [],
    redirect: indexFiidx42IKNMeta?.redirect,
    component: () => import("/app/pages/index.tsx").then(m => m.default || m),
    children: [
  {
    name: _91rootName_93PiLmSgbIYrMeta?.name ?? "index-rootName",
    path: _91rootName_93PiLmSgbIYrMeta?.path ?? ":rootName()",
    meta: _91rootName_93PiLmSgbIYrMeta || {},
    alias: _91rootName_93PiLmSgbIYrMeta?.alias || [],
    redirect: _91rootName_93PiLmSgbIYrMeta?.redirect,
    component: () => import("/app/pages/index/[rootName].vue").then(m => m.default || m)
  },
  {
    name: air_45taxiV1tr9pPw1oMeta?.name ?? "index-air-taxi",
    path: air_45taxiV1tr9pPw1oMeta?.path ?? "air-taxi",
    meta: air_45taxiV1tr9pPw1oMeta || {},
    alias: air_45taxiV1tr9pPw1oMeta?.alias || [],
    redirect: air_45taxiV1tr9pPw1oMeta?.redirect,
    component: () => import("/app/pages/index/air-taxi.vue").then(m => m.default || m)
  },
  {
    name: bus_45ticketrqiYQsKUNfMeta?.name ?? "index-bus-ticket",
    path: bus_45ticketrqiYQsKUNfMeta?.path ?? "bus-ticket",
    meta: bus_45ticketrqiYQsKUNfMeta || {},
    alias: bus_45ticketrqiYQsKUNfMeta?.alias || [],
    redirect: bus_45ticketrqiYQsKUNfMeta?.redirect,
    component: () => import("/app/pages/index/bus-ticket.vue").then(m => m.default || m)
  },
  {
    name: _91code_93hWX7QeCC2wMeta?.name ?? "index-buses-code",
    path: _91code_93hWX7QeCC2wMeta?.path ?? "buses/:code()",
    meta: _91code_93hWX7QeCC2wMeta || {},
    alias: _91code_93hWX7QeCC2wMeta?.alias || [],
    redirect: _91code_93hWX7QeCC2wMeta?.redirect,
    component: () => import("/app/pages/index/buses/[code].vue").then(m => m.default || m)
  },
  {
    name: _91provider_93eoOLjyM5IvMeta?.name ?? "index-buses-providers-provider",
    path: _91provider_93eoOLjyM5IvMeta?.path ?? "buses/providers/:provider()",
    meta: _91provider_93eoOLjyM5IvMeta || {},
    alias: _91provider_93eoOLjyM5IvMeta?.alias || [],
    redirect: _91provider_93eoOLjyM5IvMeta?.redirect,
    component: () => import("/app/pages/index/buses/providers/[provider].vue").then(m => m.default || m)
  },
  {
    name: indexW1X9WJECXYMeta?.name ?? "index-buses-providers",
    path: indexW1X9WJECXYMeta?.path ?? "buses/providers",
    meta: indexW1X9WJECXYMeta || {},
    alias: indexW1X9WJECXYMeta?.alias || [],
    redirect: indexW1X9WJECXYMeta?.redirect,
    component: () => import("/app/pages/index/buses/providers/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_93HRhttBAUs4Meta?.name ?? "index-car-rental-code",
    path: _91code_93HRhttBAUs4Meta?.path ?? "car-rental/:code()",
    meta: _91code_93HRhttBAUs4Meta || {},
    alias: _91code_93HRhttBAUs4Meta?.alias || [],
    redirect: _91code_93HRhttBAUs4Meta?.redirect,
    component: () => import("/app/pages/index/car-rental/[code].vue").then(m => m.default || m)
  },
  {
    name: indexz14zF0dozcMeta?.name ?? "index-car-rental",
    path: indexz14zF0dozcMeta?.path ?? "car-rental",
    meta: indexz14zF0dozcMeta || {},
    alias: indexz14zF0dozcMeta?.alias || [],
    redirect: indexz14zF0dozcMeta?.redirect,
    component: () => import("/app/pages/index/car-rental/index.vue").then(m => m.default || m)
  },
  {
    name: charterK04y7OvSmcMeta?.name ?? "index-charter",
    path: charterK04y7OvSmcMeta?.path ?? "charter",
    meta: charterK04y7OvSmcMeta || {},
    alias: charterK04y7OvSmcMeta?.alias || [],
    redirect: charterK04y7OvSmcMeta?.redirect,
    component: () => import("/app/pages/index/charter.vue").then(m => m.default || m)
  },
  {
    name: _91code_93L8jhn2dbQOMeta?.name ?? "index-flights-code",
    path: _91code_93L8jhn2dbQOMeta?.path ?? "flights/:code()",
    meta: _91code_93L8jhn2dbQOMeta || {},
    alias: _91code_93L8jhn2dbQOMeta?.alias || [],
    redirect: _91code_93L8jhn2dbQOMeta?.redirect,
    component: () => import("/app/pages/index/flights/[code].vue").then(m => m.default || m)
  },
  {
    name: _91provider_93N9x8N3oyjBMeta?.name ?? "index-flights-providers-provider",
    path: _91provider_93N9x8N3oyjBMeta?.path ?? "flights/providers/:provider()",
    meta: _91provider_93N9x8N3oyjBMeta || {},
    alias: _91provider_93N9x8N3oyjBMeta?.alias || [],
    redirect: _91provider_93N9x8N3oyjBMeta?.redirect,
    component: () => import("/app/pages/index/flights/providers/[provider].vue").then(m => m.default || m)
  },
  {
    name: indexRjPRIRUIAXMeta?.name ?? "index-flights-providers",
    path: indexRjPRIRUIAXMeta?.path ?? "flights/providers",
    meta: indexRjPRIRUIAXMeta || {},
    alias: indexRjPRIRUIAXMeta?.alias || [],
    redirect: indexRjPRIRUIAXMeta?.redirect,
    component: () => import("/app/pages/index/flights/providers/index.vue").then(m => m.default || m)
  },
  {
    name: index7dVwbHWQYgMeta?.name ?? "index-hotel",
    path: index7dVwbHWQYgMeta?.path ?? "hotel",
    meta: index7dVwbHWQYgMeta || {},
    alias: index7dVwbHWQYgMeta?.alias || [],
    redirect: index7dVwbHWQYgMeta?.redirect,
    component: () => import("/app/pages/index/hotel/index.vue").then(m => m.default || m)
  },
  {
    name: index3J5r3Sf7qAMeta?.name ?? "index",
    path: index3J5r3Sf7qAMeta?.path ?? "",
    meta: index3J5r3Sf7qAMeta || {},
    alias: index3J5r3Sf7qAMeta?.alias || [],
    redirect: index3J5r3Sf7qAMeta?.redirect,
    component: () => import("/app/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: international_45flightshROP26skMMMeta?.name ?? "index-international-flights",
    path: international_45flightshROP26skMMMeta?.path ?? "international-flights",
    meta: international_45flightshROP26skMMMeta || {},
    alias: international_45flightshROP26skMMMeta?.alias || [],
    redirect: international_45flightshROP26skMMMeta?.redirect,
    component: () => import("/app/pages/index/international-flights.vue").then(m => m.default || m)
  },
  {
    name: plane_45ticketWyyA4ZcXfsMeta?.name ?? "index-plane-ticket",
    path: plane_45ticketWyyA4ZcXfsMeta?.path ?? "plane-ticket",
    meta: plane_45ticketWyyA4ZcXfsMeta || {},
    alias: plane_45ticketWyyA4ZcXfsMeta?.alias || [],
    redirect: plane_45ticketWyyA4ZcXfsMeta?.redirect,
    component: () => import("/app/pages/index/plane-ticket.vue").then(m => m.default || m)
  },
  {
    name: _91code_933ZOKnJtQdtMeta?.name ?? "index-ship-ticket-code",
    path: _91code_933ZOKnJtQdtMeta?.path ?? "ship-ticket/:code()",
    meta: _91code_933ZOKnJtQdtMeta || {},
    alias: _91code_933ZOKnJtQdtMeta?.alias || [],
    redirect: _91code_933ZOKnJtQdtMeta?.redirect,
    component: () => import("/app/pages/index/ship-ticket/[code].vue").then(m => m.default || m)
  },
  {
    name: indexzO6c3cwHqmMeta?.name ?? "index-ship-ticket",
    path: indexzO6c3cwHqmMeta?.path ?? "ship-ticket",
    meta: indexzO6c3cwHqmMeta || {},
    alias: indexzO6c3cwHqmMeta?.alias || [],
    redirect: indexzO6c3cwHqmMeta?.redirect,
    component: () => import("/app/pages/index/ship-ticket/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_93SWH3sFQStCMeta?.name ?? "index-taxi-code",
    path: _91code_93SWH3sFQStCMeta?.path ?? "taxi/:code()",
    meta: _91code_93SWH3sFQStCMeta || {},
    alias: _91code_93SWH3sFQStCMeta?.alias || [],
    redirect: _91code_93SWH3sFQStCMeta?.redirect,
    component: () => import("/app/pages/index/taxi/[code].vue").then(m => m.default || m)
  },
  {
    name: indexEN4lYa0X3SMeta?.name ?? "index-taxi",
    path: indexEN4lYa0X3SMeta?.path ?? "taxi",
    meta: indexEN4lYa0X3SMeta || {},
    alias: indexEN4lYa0X3SMeta?.alias || [],
    redirect: indexEN4lYa0X3SMeta?.redirect,
    component: () => import("/app/pages/index/taxi/index.vue").then(m => m.default || m)
  },
  {
    name: tour7G4rBNNv4RMeta?.name ?? "index-tour",
    path: tour7G4rBNNv4RMeta?.path ?? "tour",
    meta: tour7G4rBNNv4RMeta || {},
    alias: tour7G4rBNNv4RMeta?.alias || [],
    redirect: tour7G4rBNNv4RMeta?.redirect,
    component: () => import("/app/pages/index/tour.vue").then(m => m.default || m)
  },
  {
    name: _91inner_9337DlmEp8hSMeta?.name ?? "index-train-ticket-name-inner",
    path: _91inner_9337DlmEp8hSMeta?.path ?? "train-ticket/:name()/:inner()",
    meta: _91inner_9337DlmEp8hSMeta || {},
    alias: _91inner_9337DlmEp8hSMeta?.alias || [],
    redirect: _91inner_9337DlmEp8hSMeta?.redirect,
    component: () => import("/app/pages/index/train-ticket/[name]/[inner].vue").then(m => m.default || m)
  },
  {
    name: indexMAd01lhldsMeta?.name ?? "index-train-ticket-name",
    path: indexMAd01lhldsMeta?.path ?? "train-ticket/:name()",
    meta: indexMAd01lhldsMeta || {},
    alias: indexMAd01lhldsMeta?.alias || [],
    redirect: indexMAd01lhldsMeta?.redirect,
    component: () => import("/app/pages/index/train-ticket/[name]/index.vue").then(m => m.default || m)
  },
  {
    name: indexwtdfqzQe8qMeta?.name ?? "index-train-ticket",
    path: indexwtdfqzQe8qMeta?.path ?? "train-ticket",
    meta: indexwtdfqzQe8qMeta || {},
    alias: indexwtdfqzQe8qMeta?.alias || [],
    redirect: indexwtdfqzQe8qMeta?.redirect,
    component: () => import("/app/pages/index/train-ticket/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_93P83VAo1a0XMeta?.name ?? "index-trains-code",
    path: _91code_93P83VAo1a0XMeta?.path ?? "trains/:code()",
    meta: _91code_93P83VAo1a0XMeta || {},
    alias: _91code_93P83VAo1a0XMeta?.alias || [],
    redirect: _91code_93P83VAo1a0XMeta?.redirect,
    component: () => import("/app/pages/index/trains/[code].vue").then(m => m.default || m)
  },
  {
    name: _91provider_930qLpraNgw7Meta?.name ?? "index-trains-providers-provider",
    path: _91provider_930qLpraNgw7Meta?.path ?? "trains/providers/:provider()",
    meta: _91provider_930qLpraNgw7Meta || {},
    alias: _91provider_930qLpraNgw7Meta?.alias || [],
    redirect: _91provider_930qLpraNgw7Meta?.redirect,
    component: () => import("/app/pages/index/trains/providers/[provider].vue").then(m => m.default || m)
  },
  {
    name: index51ab2qa2LuMeta?.name ?? "index-trains-providers",
    path: index51ab2qa2LuMeta?.path ?? "trains/providers",
    meta: index51ab2qa2LuMeta || {},
    alias: index51ab2qa2LuMeta?.alias || [],
    redirect: index51ab2qa2LuMeta?.redirect,
    component: () => import("/app/pages/index/trains/providers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: loginhHM0vSTW5jMeta?.name ?? "login",
    path: loginhHM0vSTW5jMeta?.path ?? "/login",
    meta: loginhHM0vSTW5jMeta || {},
    alias: loginhHM0vSTW5jMeta?.alias || [],
    redirect: loginhHM0vSTW5jMeta?.redirect,
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: mr_45index8CMfyvjNFmMeta?.name ?? "mr-index",
    path: mr_45index8CMfyvjNFmMeta?.path ?? "/mr-index",
    meta: mr_45index8CMfyvjNFmMeta || {},
    alias: mr_45index8CMfyvjNFmMeta?.alias || [],
    redirect: mr_45index8CMfyvjNFmMeta?.redirect,
    component: () => import("/app/pages/mr-index.vue").then(m => m.default || m)
  },
  {
    name: org2n1R1gxsfBMeta?.name ?? "org",
    path: org2n1R1gxsfBMeta?.path ?? "/org",
    meta: org2n1R1gxsfBMeta || {},
    alias: org2n1R1gxsfBMeta?.alias || [],
    redirect: org2n1R1gxsfBMeta?.redirect,
    component: () => import("/app/pages/org.vue").then(m => m.default || m),
    children: [
  {
    name: downloadTicketsoT66ur7rTOMeta?.name ?? "org-downloadTickets",
    path: downloadTicketsoT66ur7rTOMeta?.path ?? "downloadTickets",
    meta: downloadTicketsoT66ur7rTOMeta || {},
    alias: downloadTicketsoT66ur7rTOMeta?.alias || [],
    redirect: downloadTicketsoT66ur7rTOMeta?.redirect,
    component: () => import("/app/pages/org/downloadTickets.vue").then(m => m.default || m)
  },
  {
    name: hotelFactorecHqiFKz7wMeta?.name ?? "org-hotelFactor",
    path: hotelFactorecHqiFKz7wMeta?.path ?? "hotelFactor",
    meta: hotelFactorecHqiFKz7wMeta || {},
    alias: hotelFactorecHqiFKz7wMeta?.alias || [],
    redirect: hotelFactorecHqiFKz7wMeta?.redirect,
    component: () => import("/app/pages/org/hotelFactor.vue").then(m => m.default || m)
  },
  {
    name: index55WIOoOHBHMeta?.name ?? "org-purchaseReport",
    path: index55WIOoOHBHMeta?.path ?? "purchaseReport",
    meta: index55WIOoOHBHMeta || {},
    alias: index55WIOoOHBHMeta?.alias || [],
    redirect: index55WIOoOHBHMeta?.redirect,
    component: () => import("/app/pages/org/purchaseReport/index.vue").then(m => m.default || m)
  },
  {
    name: details5TkiLf315WMeta?.name ?? "org-statusReport-details",
    path: details5TkiLf315WMeta?.path ?? "statusReport/details",
    meta: details5TkiLf315WMeta || {},
    alias: details5TkiLf315WMeta?.alias || [],
    redirect: details5TkiLf315WMeta?.redirect,
    component: () => import("/app/pages/org/statusReport/details.vue").then(m => m.default || m)
  },
  {
    name: index8gntQCwxHdMeta?.name ?? "org-statusReport",
    path: index8gntQCwxHdMeta?.path ?? "statusReport",
    meta: index8gntQCwxHdMeta || {},
    alias: index8gntQCwxHdMeta?.alias || [],
    redirect: index8gntQCwxHdMeta?.redirect,
    component: () => import("/app/pages/org/statusReport/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: panel7hVK6F0xvXMeta?.name ?? undefined,
    path: panel7hVK6F0xvXMeta?.path ?? "/panel",
    meta: panel7hVK6F0xvXMeta || {},
    alias: panel7hVK6F0xvXMeta?.alias || [],
    redirect: panel7hVK6F0xvXMeta?.redirect,
    component: () => import("/app/pages/panel.vue").then(m => m.default || m),
    children: [
  {
    name: addPassengerWGlfZVmf25Meta?.name ?? "panel-addPassenger",
    path: addPassengerWGlfZVmf25Meta?.path ?? "addPassenger",
    meta: addPassengerWGlfZVmf25Meta || {},
    alias: addPassengerWGlfZVmf25Meta?.alias || [],
    redirect: addPassengerWGlfZVmf25Meta?.redirect,
    component: () => import("/app/pages/panel/addPassenger.vue").then(m => m.default || m)
  },
  {
    name: _91billId_93HauutDKGzNMeta?.name ?? "panel-auto-reserve-id-billId",
    path: _91billId_93HauutDKGzNMeta?.path ?? "auto-reserve/:id()/:billId()",
    meta: _91billId_93HauutDKGzNMeta || {},
    alias: _91billId_93HauutDKGzNMeta?.alias || [],
    redirect: _91billId_93HauutDKGzNMeta?.redirect,
    component: () => import("/app/pages/panel/auto-reserve/[id]/[billId].vue").then(m => m.default || m)
  },
  {
    name: indexPaguqZLPkrMeta?.name ?? "panel-auto-reserve-id",
    path: indexPaguqZLPkrMeta?.path ?? "auto-reserve/:id()",
    meta: indexPaguqZLPkrMeta || {},
    alias: indexPaguqZLPkrMeta?.alias || [],
    redirect: indexPaguqZLPkrMeta?.redirect,
    component: () => import("/app/pages/panel/auto-reserve/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexg7ylByDl4VMeta?.name ?? "panel-auto-reserve",
    path: indexg7ylByDl4VMeta?.path ?? "auto-reserve",
    meta: indexg7ylByDl4VMeta || {},
    alias: indexg7ylByDl4VMeta?.alias || [],
    redirect: indexg7ylByDl4VMeta?.redirect,
    component: () => import("/app/pages/panel/auto-reserve/index.vue").then(m => m.default || m)
  },
  {
    name: historyF5Dq7DwnNdMeta?.name ?? "panel-club-history",
    path: historyF5Dq7DwnNdMeta?.path ?? "club/history",
    meta: historyF5Dq7DwnNdMeta || {},
    alias: historyF5Dq7DwnNdMeta?.alias || [],
    redirect: historyF5Dq7DwnNdMeta?.redirect,
    component: () => import("/app/pages/panel/club/history.vue").then(m => m.default || m)
  },
  {
    name: indexmjXSFkcLsFMeta?.name ?? "panel-club",
    path: indexmjXSFkcLsFMeta?.path ?? "club",
    meta: indexmjXSFkcLsFMeta || {},
    alias: indexmjXSFkcLsFMeta?.alias || [],
    redirect: indexmjXSFkcLsFMeta?.redirect,
    component: () => import("/app/pages/panel/club/index.vue").then(m => m.default || m)
  },
  {
    name: level52MLFTApfqMeta?.name ?? "panel-club-level",
    path: level52MLFTApfqMeta?.path ?? "club/level",
    meta: level52MLFTApfqMeta || {},
    alias: level52MLFTApfqMeta?.alias || [],
    redirect: level52MLFTApfqMeta?.redirect,
    component: () => import("/app/pages/panel/club/level.vue").then(m => m.default || m)
  },
  {
    name: scoresMKuXzg4bneMeta?.name ?? "panel-club-scores",
    path: scoresMKuXzg4bneMeta?.path ?? "club/scores",
    meta: scoresMKuXzg4bneMeta || {},
    alias: scoresMKuXzg4bneMeta?.alias || [],
    redirect: scoresMKuXzg4bneMeta?.redirect,
    component: () => import("/app/pages/panel/club/scores.vue").then(m => m.default || m)
  },
  {
    name: index4cf5Ag9Q9yMeta?.name ?? "panel-credit",
    path: index4cf5Ag9Q9yMeta?.path ?? "credit",
    meta: index4cf5Ag9Q9yMeta || {},
    alias: index4cf5Ag9Q9yMeta?.alias || [],
    redirect: index4cf5Ag9Q9yMeta?.redirect,
    component: () => import("/app/pages/panel/credit/index.vue").then(m => m.default || m)
  },
  {
    name: indexo76gkEoZmgMeta?.name ?? "panel-gift-cards",
    path: indexo76gkEoZmgMeta?.path ?? "gift-cards",
    meta: indexo76gkEoZmgMeta || {},
    alias: indexo76gkEoZmgMeta?.alias || [],
    redirect: indexo76gkEoZmgMeta?.redirect,
    component: () => import("/app/pages/panel/gift-cards/index.vue").then(m => m.default || m)
  },
  {
    name: indexnCUfp2msl3Meta?.name ?? "panel-index",
    path: indexnCUfp2msl3Meta?.path ?? "",
    meta: indexnCUfp2msl3Meta || {},
    alias: indexnCUfp2msl3Meta?.alias || [],
    redirect: indexnCUfp2msl3Meta?.redirect,
    component: () => import("/app/pages/panel/index/index.vue").then(m => m.default || m)
  },
  {
    name: indexkjLCehs3zuMeta?.name ?? "panel-messages",
    path: indexkjLCehs3zuMeta?.path ?? "messages",
    meta: indexkjLCehs3zuMeta || {},
    alias: indexkjLCehs3zuMeta?.alias || [],
    redirect: indexkjLCehs3zuMeta?.redirect,
    component: () => import("/app/pages/panel/messages/index.vue").then(m => m.default || m)
  },
  {
    name: indexoikjwP7eo2Meta?.name ?? "panel-pax",
    path: indexoikjwP7eo2Meta?.path ?? "pax",
    meta: indexoikjwP7eo2Meta || {},
    alias: indexoikjwP7eo2Meta?.alias || [],
    redirect: indexoikjwP7eo2Meta?.redirect,
    component: () => import("/app/pages/panel/pax/index.vue").then(m => m.default || m)
  },
  {
    name: indexYYB617BrvZMeta?.name ?? "panel-reserves",
    path: indexYYB617BrvZMeta?.path ?? "reserves",
    meta: indexYYB617BrvZMeta || {},
    alias: indexYYB617BrvZMeta?.alias || [],
    redirect: indexYYB617BrvZMeta?.redirect,
    component: () => import("/app/pages/panel/reserves/index.vue").then(m => m.default || m)
  },
  {
    name: index0T43KXNAjlMeta?.name ?? "panel-robot",
    path: index0T43KXNAjlMeta?.path ?? "robot",
    meta: index0T43KXNAjlMeta || {},
    alias: index0T43KXNAjlMeta?.alias || [],
    redirect: index0T43KXNAjlMeta?.redirect,
    component: () => import("/app/pages/panel/robot/index.vue").then(m => m.default || m)
  },
  {
    name: indexb5G7ldEeI6Meta?.name ?? "panel-trackings",
    path: indexb5G7ldEeI6Meta?.path ?? "trackings",
    meta: indexb5G7ldEeI6Meta || {},
    alias: indexb5G7ldEeI6Meta?.alias || [],
    redirect: indexb5G7ldEeI6Meta?.redirect,
    component: () => import("/app/pages/panel/trackings/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexaeouN7Kzh7Meta?.name ?? "profile",
    path: indexaeouN7Kzh7Meta?.path ?? "/profile",
    meta: indexaeouN7Kzh7Meta || {},
    alias: indexaeouN7Kzh7Meta?.alias || [],
    redirect: indexaeouN7Kzh7Meta?.redirect,
    component: () => import("/app/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexD5v8i8GbLlMeta?.name ?? "reserve-auto-reserve-filters",
    path: indexD5v8i8GbLlMeta?.path ?? "/reserve/auto-reserve/filters",
    meta: indexD5v8i8GbLlMeta || {},
    alias: indexD5v8i8GbLlMeta?.alias || [],
    redirect: indexD5v8i8GbLlMeta?.redirect,
    component: () => import("/app/pages/reserve/auto-reserve/filters/index.vue").then(m => m.default || m)
  },
  {
    name: indexXW1ZIMTKwyMeta?.name ?? "reserve-auto-reserve",
    path: indexXW1ZIMTKwyMeta?.path ?? "/reserve/auto-reserve",
    meta: indexXW1ZIMTKwyMeta || {},
    alias: indexXW1ZIMTKwyMeta?.alias || [],
    redirect: indexXW1ZIMTKwyMeta?.redirect,
    component: () => import("/app/pages/reserve/auto-reserve/index.vue").then(m => m.default || m)
  },
  {
    name: indexvMGHc9fqGoMeta?.name ?? "reserve-auto",
    path: indexvMGHc9fqGoMeta?.path ?? "/reserve/auto",
    meta: indexvMGHc9fqGoMeta || {},
    alias: indexvMGHc9fqGoMeta?.alias || [],
    redirect: indexvMGHc9fqGoMeta?.redirect,
    component: () => import("/app/pages/reserve/auto/index.vue").then(m => m.default || m)
  },
  {
    name: floating3QCs7DkpofMeta?.name ?? "reserve-floating",
    path: floating3QCs7DkpofMeta?.path ?? "/reserve/floating",
    meta: floating3QCs7DkpofMeta || {},
    alias: floating3QCs7DkpofMeta?.alias || [],
    redirect: floating3QCs7DkpofMeta?.redirect,
    component: () => import("/app/pages/reserve/floating.vue").then(m => m.default || m)
  },
  {
    name: indexkYjUxQxG9IMeta?.name ?? "reserve-form",
    path: indexkYjUxQxG9IMeta?.path ?? "/reserve/form",
    meta: indexkYjUxQxG9IMeta || {},
    alias: indexkYjUxQxG9IMeta?.alias || [],
    redirect: indexkYjUxQxG9IMeta?.redirect,
    component: () => import("/app/pages/reserve/form/index.vue").then(m => m.default || m)
  },
  {
    name: indexnMeaEGSw8zMeta?.name ?? "reserve-prepay",
    path: indexnMeaEGSw8zMeta?.path ?? "/reserve/prepay",
    meta: indexnMeaEGSw8zMeta || {},
    alias: indexnMeaEGSw8zMeta?.alias || [],
    redirect: indexnMeaEGSw8zMeta?.redirect,
    component: () => import("/app/pages/reserve/prepay/index.vue").then(m => m.default || m)
  },
  {
    name: indexsh8o87md7VMeta?.name ?? "reserve-raise",
    path: indexsh8o87md7VMeta?.path ?? "/reserve/raise",
    meta: indexsh8o87md7VMeta || {},
    alias: indexsh8o87md7VMeta?.alias || [],
    redirect: indexsh8o87md7VMeta?.redirect,
    component: () => import("/app/pages/reserve/raise/index.vue").then(m => m.default || m)
  },
  {
    name: indexmjydbmT8M8Meta?.name ?? "services",
    path: indexmjydbmT8M8Meta?.path ?? "/services",
    meta: indexmjydbmT8M8Meta || {},
    alias: indexmjydbmT8M8Meta?.alias || [],
    redirect: indexmjydbmT8M8Meta?.redirect,
    component: () => import("/app/pages/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexrVEAE3qysDMeta?.name ?? "support",
    path: indexrVEAE3qysDMeta?.path ?? "/support",
    meta: indexrVEAE3qysDMeta || {},
    alias: indexrVEAE3qysDMeta?.alias || [],
    redirect: indexrVEAE3qysDMeta?.redirect,
    component: () => import("/app/pages/support/index.vue").then(m => m.default || m),
    children: [
  {
    name: detailsOV1ee9OX0kMeta?.name ?? "support-index-details",
    path: detailsOV1ee9OX0kMeta?.path ?? "details",
    meta: detailsOV1ee9OX0kMeta || {},
    alias: detailsOV1ee9OX0kMeta?.alias || [],
    redirect: detailsOV1ee9OX0kMeta?.redirect,
    component: () => import("/app/pages/support/index/details.vue").then(m => m.default || m)
  },
  {
    name: faqSzLyQjvpX7Meta?.name ?? "support-index-faq",
    path: faqSzLyQjvpX7Meta?.path ?? "faq",
    meta: faqSzLyQjvpX7Meta || {},
    alias: faqSzLyQjvpX7Meta?.alias || [],
    redirect: faqSzLyQjvpX7Meta?.redirect,
    component: () => import("/app/pages/support/index/faq.vue").then(m => m.default || m)
  },
  {
    name: feedbackEuOmwbcx8oMeta?.name ?? "support-index-feedback",
    path: feedbackEuOmwbcx8oMeta?.path ?? "feedback",
    meta: feedbackEuOmwbcx8oMeta || {},
    alias: feedbackEuOmwbcx8oMeta?.alias || [],
    redirect: feedbackEuOmwbcx8oMeta?.redirect,
    component: () => import("/app/pages/support/index/feedback.vue").then(m => m.default || m)
  },
  {
    name: guidey9hie2KZVZMeta?.name ?? "support-index-guide",
    path: guidey9hie2KZVZMeta?.path ?? "guide",
    meta: guidey9hie2KZVZMeta || {},
    alias: guidey9hie2KZVZMeta?.alias || [],
    redirect: guidey9hie2KZVZMeta?.redirect,
    component: () => import("/app/pages/support/index/guide.vue").then(m => m.default || m),
    children: [
  {
    name: paymentxxxhb6dQFZMeta?.name ?? "support-index-guide-payment",
    path: paymentxxxhb6dQFZMeta?.path ?? "payment",
    meta: paymentxxxhb6dQFZMeta || {},
    alias: paymentxxxhb6dQFZMeta?.alias || [],
    redirect: paymentxxxhb6dQFZMeta?.redirect,
    component: () => import("/app/pages/support/index/guide/payment.vue").then(m => m.default || m)
  },
  {
    name: reservationbA9pInCuy0Meta?.name ?? "support-index-guide-reservation",
    path: reservationbA9pInCuy0Meta?.path ?? "reservation",
    meta: reservationbA9pInCuy0Meta || {},
    alias: reservationbA9pInCuy0Meta?.alias || [],
    redirect: reservationbA9pInCuy0Meta?.redirect,
    component: () => import("/app/pages/support/index/guide/reservation.vue").then(m => m.default || m)
  }
]
  },
  {
    name: ibane44omNhhnSMeta?.name ?? "support-index-iban",
    path: ibane44omNhhnSMeta?.path ?? "iban",
    meta: ibane44omNhhnSMeta || {},
    alias: ibane44omNhhnSMeta?.alias || [],
    redirect: ibane44omNhhnSMeta?.redirect,
    component: () => import("/app/pages/support/index/iban.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policynKsIz79tYoMeta?.name ?? "support-index-privacy-policy",
    path: privacy_45policynKsIz79tYoMeta?.path ?? "privacy-policy",
    meta: privacy_45policynKsIz79tYoMeta || {},
    alias: privacy_45policynKsIz79tYoMeta?.alias || [],
    redirect: privacy_45policynKsIz79tYoMeta?.redirect,
    component: () => import("/app/pages/support/index/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsK01Mq8jqJ7Meta?.name ?? "support-index-terms-and-conditions",
    path: terms_45and_45conditionsK01Mq8jqJ7Meta?.path ?? "terms-and-conditions",
    meta: terms_45and_45conditionsK01Mq8jqJ7Meta || {},
    alias: terms_45and_45conditionsK01Mq8jqJ7Meta?.alias || [],
    redirect: terms_45and_45conditionsK01Mq8jqJ7Meta?.redirect,
    component: () => import("/app/pages/support/index/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: trackingeZdpDvxkeYMeta?.name ?? "support-index-tracking",
    path: trackingeZdpDvxkeYMeta?.path ?? "tracking",
    meta: trackingeZdpDvxkeYMeta || {},
    alias: trackingeZdpDvxkeYMeta?.alias || [],
    redirect: trackingeZdpDvxkeYMeta?.redirect,
    component: () => import("/app/pages/support/index/tracking.vue").then(m => m.default || m)
  },
  {
    name: uploadIJZ1qPZvsuMeta?.name ?? "support-index-upload",
    path: uploadIJZ1qPZvsuMeta?.path ?? "upload",
    meta: uploadIJZ1qPZvsuMeta || {},
    alias: uploadIJZ1qPZvsuMeta?.alias || [],
    redirect: uploadIJZ1qPZvsuMeta?.redirect,
    component: () => import("/app/pages/support/index/upload.vue").then(m => m.default || m)
  },
  {
    name: who_45is_45aptcHZo0UVpwkMeta?.name ?? "support-index-who-is-apt",
    path: who_45is_45aptcHZo0UVpwkMeta?.path ?? "who-is-apt",
    meta: who_45is_45aptcHZo0UVpwkMeta || {},
    alias: who_45is_45aptcHZo0UVpwkMeta?.alias || [],
    redirect: who_45is_45aptcHZo0UVpwkMeta?.redirect,
    component: () => import("/app/pages/support/index/who-is-apt.vue").then(m => m.default || m)
  },
  {
    name: who_45is_45hemF9xvw5aDYMeta?.name ?? "support-index-who-is-he",
    path: who_45is_45hemF9xvw5aDYMeta?.path ?? "who-is-he",
    meta: who_45is_45hemF9xvw5aDYMeta || {},
    alias: who_45is_45hemF9xvw5aDYMeta?.alias || [],
    redirect: who_45is_45hemF9xvw5aDYMeta?.redirect,
    component: () => import("/app/pages/support/index/who-is-he.vue").then(m => m.default || m)
  },
  {
    name: terms_45and_45conditionsK01Mq8jqJ7Meta?.name ?? "TermsAndConditionsApp",
    path: terms_45and_45conditionsK01Mq8jqJ7Meta?.path ?? "/support/terms-and-conditions-app",
    meta: { ...(terms_45and_45conditionsK01Mq8jqJ7Meta || {}), ...{"whiteLabel":"mrbilit","layout":"pure"} },
    alias: terms_45and_45conditionsK01Mq8jqJ7Meta?.alias || [],
    redirect: terms_45and_45conditionsK01Mq8jqJ7Meta?.redirect,
    component: () => import("/app/pages/support/index/terms-and-conditions.vue").then(m => m.default || m)
  },
  {
    name: who_45is_45hemF9xvw5aDYMeta?.name ?? "WhoIsHeApp",
    path: who_45is_45hemF9xvw5aDYMeta?.path ?? "/support/who-is-he-app",
    meta: { ...(who_45is_45hemF9xvw5aDYMeta || {}), ...{"whiteLabel":"mrbilit","layout":"pure"} },
    alias: who_45is_45hemF9xvw5aDYMeta?.alias || [],
    redirect: who_45is_45hemF9xvw5aDYMeta?.redirect,
    component: () => import("/app/pages/support/index/who-is-he.vue").then(m => m.default || m)
  },
  {
    name: faqSzLyQjvpX7Meta?.name ?? "FaqApp",
    path: faqSzLyQjvpX7Meta?.path ?? "/support/faq-app",
    meta: { ...(faqSzLyQjvpX7Meta || {}), ...{"whiteLabel":"mrbilit","layout":"pure"} },
    alias: faqSzLyQjvpX7Meta?.alias || [],
    redirect: faqSzLyQjvpX7Meta?.redirect,
    component: () => import("/app/pages/support/index/faq.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "view",
    path: indexOltAc8HSPiMeta?.path ?? "/view",
    meta: indexOltAc8HSPiMeta || {},
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: widgetzMSPHa954TMeta?.name ?? "widget",
    path: widgetzMSPHa954TMeta?.path ?? "/widget",
    meta: widgetzMSPHa954TMeta || {},
    alias: widgetzMSPHa954TMeta?.alias || [],
    redirect: widgetzMSPHa954TMeta?.redirect,
    component: () => import("/app/pages/widget.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewBundles",
    path: indexOltAc8HSPiMeta?.path ?? "/tour/:origin(\\d+)/:destination(\\d+)",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexl4EdCGhmEGMeta?.name ?? "BundleSelectRooms",
    path: indexl4EdCGhmEGMeta?.path ?? "/tour/residence/:origin(\\d+)/:destination(\\d+)",
    meta: { ...(indexl4EdCGhmEGMeta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: indexl4EdCGhmEGMeta?.alias || [],
    redirect: indexl4EdCGhmEGMeta?.redirect,
    component: () => import("/app/pages/hotel/[city]/[hotelName]/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewOldFlights",
    path: indexOltAc8HSPiMeta?.path ?? "/flights/:origin([a-zA-Z]{3,6})-:destination([a-zA-Z]{3,6})/:departureDate(\\d{4}-\\d{1,2}-\\d{1,2})/:returnDate?/:adultCount?/:childCount?/:infantCount?/:cabinClass?",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"isLegacy":true} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewFlights",
    path: indexOltAc8HSPiMeta?.path ?? "/flights/:origin([a-zA-Z]{3,6})-:destination([a-zA-Z]{3,6})",
    meta: indexOltAc8HSPiMeta || {},
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexvMGHc9fqGoMeta?.name ?? "AutoReserveFlights",
    path: indexvMGHc9fqGoMeta?.path ?? "/reserve/auto/flights/:origin([a-z][a-z_0-9]+|\\d+)-:destination([a-z][a-z_0-9]+|\\d+)",
    meta: indexvMGHc9fqGoMeta || {},
    alias: indexvMGHc9fqGoMeta?.alias || [],
    redirect: indexvMGHc9fqGoMeta?.redirect,
    component: () => import("/app/pages/reserve/auto/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewOldTrains",
    path: indexOltAc8HSPiMeta?.path ?? "/trains/:origin(\\d+)/:destination(\\d+)/:departureDate?/:returnDate?/:adultCount?/:childCount?/:infantCount?/:sellTypeCode?/:exclusive?",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit","isLegacy":true} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewTrains",
    path: indexOltAc8HSPiMeta?.path ?? "/trains/:origin([a-z_]+)-:destination([a-z_]+)",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewOldBuses",
    path: indexOltAc8HSPiMeta?.path ?? "/buses/:origin(\\d+)/:destination(\\d+)/:departureDate?/:returnDate?/:adultCount?",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit","isLegacy":true} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewBuses",
    path: indexOltAc8HSPiMeta?.path ?? "/buses/:origin([a-z][a-z_0-9]+|\\d+)-:destination([a-z][a-z_0-9]+|\\d+)",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexvMGHc9fqGoMeta?.name ?? "AutoReserveBuses",
    path: indexvMGHc9fqGoMeta?.path ?? "/reserve/auto/buses/:origin([a-z][a-z_0-9]+|\\d+)-:destination([a-z][a-z_0-9]+|\\d+)",
    meta: indexvMGHc9fqGoMeta || {},
    alias: indexvMGHc9fqGoMeta?.alias || [],
    redirect: indexvMGHc9fqGoMeta?.redirect,
    component: () => import("/app/pages/reserve/auto/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewOldTaxies",
    path: indexOltAc8HSPiMeta?.path ?? "/taxi/:origin(\\d+)/:destination(\\d+)/:departureDate?/:returnDate?/:adultCount?",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit","isLegacy":true} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: indexOltAc8HSPiMeta?.name ?? "ViewTaxies",
    path: indexOltAc8HSPiMeta?.path ?? "/taxi/:origin([a-z_]+|\\d+)-:destination([a-z_]+|\\d+)",
    meta: { ...(indexOltAc8HSPiMeta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: indexOltAc8HSPiMeta?.alias || [],
    redirect: indexOltAc8HSPiMeta?.redirect,
    component: () => import("/app/pages/view/index.vue").then(m => m.default || m)
  },
  {
    name: flight_45infoeUatO2CQczMeta?.name ?? undefined,
    path: flight_45infoeUatO2CQczMeta?.path ?? "/mobile/flight-info",
    meta: { ...(flight_45infoeUatO2CQczMeta || {}), ...{"whiteLabel":"mrbilit","layout":"pure"} },
    alias: flight_45infoeUatO2CQczMeta?.alias || [],
    redirect: flight_45infoeUatO2CQczMeta?.redirect,
    component: () => import("/app/pages/flight-info.vue").then(m => m.default || m),
    children: [
  {
    name: index0fGT0R7p02Meta?.name ?? "FlightInfoIndex",
    path: index0fGT0R7p02Meta?.path ?? "/mobile/flight-info",
    meta: { ...(index0fGT0R7p02Meta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: index0fGT0R7p02Meta?.alias || [],
    redirect: index0fGT0R7p02Meta?.redirect,
    component: () => import("/app/pages/flight-info/index.vue").then(m => m.default || m)
  },
  {
    name: _91airport_938I0p5SEiV2Meta?.name ?? "FlightInfoAirport",
    path: _91airport_938I0p5SEiV2Meta?.path ?? ":airport",
    meta: { ...(_91airport_938I0p5SEiV2Meta || {}), ...{"whiteLabel":"mrbilit"} },
    alias: _91airport_938I0p5SEiV2Meta?.alias || [],
    redirect: _91airport_938I0p5SEiV2Meta?.redirect,
    component: () => import("/app/pages/flight-info/[airport].vue").then(m => m.default || m)
  }
]
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name ?? undefined,
    path: component_45stubnO9MU04yTUMeta?.path ?? "/panel/who-is-he",
    meta: component_45stubnO9MU04yTUMeta || {},
    alias: component_45stubnO9MU04yTUMeta?.alias || [],
    redirect: component_45stubnO9MU04yTUMeta?.redirect,
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name ?? undefined,
    path: component_45stubnO9MU04yTUMeta?.path ?? "/deals",
    meta: component_45stubnO9MU04yTUMeta || {},
    alias: component_45stubnO9MU04yTUMeta?.alias || [],
    redirect: component_45stubnO9MU04yTUMeta?.redirect,
    component: component_45stubnO9MU04yTU
  },
  {
    name: component_45stubnO9MU04yTUMeta?.name ?? undefined,
    path: component_45stubnO9MU04yTUMeta?.path ?? "/support/guide/cancellation",
    meta: component_45stubnO9MU04yTUMeta || {},
    alias: component_45stubnO9MU04yTUMeta?.alias || [],
    redirect: component_45stubnO9MU04yTUMeta?.redirect,
    component: component_45stubnO9MU04yTU
  }
]